import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './NewArrivals.css';
import { useNavigate } from "react-router-dom";

const SellingDiscount = () => {
    const [country, setCountry] = useState('Loading...');
    const [cars, setCars] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch car details
        fetch('https://api.saadmotors.com/get-car-details.php')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                //console.log("Fetched car data:", data);
                setCars(data);
            })
            .catch(error => {
                console.error("Error fetching car details:", error);
            });
    }, []);

    const handleCarClick = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    return (
        <section>
            <div className="containers my-4">
                 <div className="carousel-bg mb-5">
                   <div className="main-title">
                        <h2>Top Export Models with Exclusive Discounts</h2>
                        <p>Proven export models delivering quality, savings, and reliability.</p>
                    </div>
                </div>
                
                <div className="row g-3">
                    {cars.slice(0, 8).map((car) => (
                        <div className="col-md-3 col-sm-6" key={car.id}>
                            <a href={`/vehicle-details/${car.id}`}>
                                <div className="car-card position-relative">
                                    <img 
                                        src={`https://api.saadmotors.com/${car.images}`} 
                                        alt={car.model} 
                                    />
                                    <div className="car-details">
                                        <p className="car-title">{car.maker} {car.model}</p>
                                        {/* <p>{car.mileage} Km<br />{car.fuel} | {car.year}</p> */}
                                        <p>{car.year} | {car.fuel} | <br /> {car.mileage} Km </p>
                                        <div className="car-price">
                                            <div className="price-row">
                                                <div className="price-label">Price:</div>
                                                <div className="price-value">
                                                    <span>${car.price}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>

                <div className="show-more text-end">
                    <button className="btn btn-lg btn-primary">Show More</button>
                </div>
            </div>
        </section>
    );
};

export default SellingDiscount;